import { Syntax } from '@cld/code-snippet-next';
import { ParsedUrlProps } from '../serverTypes';

export const createUrlSnippet = (data: ParsedUrlProps) => ({
  language: 'URL',
  versions: [{ snippet: data.url, syntax: 'url' as Syntax }],
});
